import { UserButton } from "@clerk/nextjs";
import { Box, Stack } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import { forwardRef } from "react";
import { AuthUser } from "@/auth/useAuthState";
import { useUser } from "@/auth/useUser";
import { GREY } from "@/config/mui/colorPalette";
import { useResponsive } from "@/hooks/common/useResponsive";
import { getDefaultRoute } from "@/utils";
import { CrossIcon, MenuHamburgerIcon } from "../icons";
import ImpersonationBar from "./impersonationBar";
import MaintenanceBanner from "./maintenanceBanner";
import TopBarActions from "./topBarActions";
import TopBarWrapper from "./topBarWrapper";

type Props = {
  onToggleNav: () => void;
  user: AuthUser;
  isNavOpen: boolean;
};

export const TOP_BAR_HEIGHT = "56px";

const TopBar = forwardRef<HTMLDivElement, Props>(function TopBarNavigation(
  { onToggleNav, user, isNavOpen },
  ref
) {
  const { userMedspa } = useUser();
  const mdUp = useResponsive("up", "md");

  const handleCloseNavBar = () => {
    if (isNavOpen) {
      onToggleNav();
    }
  };

  return (
    <Box
      ref={ref}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: "100%",
      }}
    >
      <MaintenanceBanner />
      <ImpersonationBar />
      <TopBarWrapper>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{
              alignContent: "center",
            }}
          >
            {!mdUp && (
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  alignItems: "center",
                }}
              >
                {isNavOpen ? (
                  <CrossIcon onClick={onToggleNav} color={GREY[50]} />
                ) : (
                  <MenuHamburgerIcon onClick={onToggleNav} color={GREY[50]} />
                )}
                <Box component={Link} href={getDefaultRoute(userMedspa)}>
                  <Image
                    src="/assets/moxie-logo.svg"
                    width={80}
                    height={20}
                    alt="Moxie logo"
                  />
                </Box>
              </Stack>
            )}
          </Stack>
          <Stack
            direction="row"
            sx={{
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <TopBarActions user={user} onCloseNavBar={handleCloseNavBar} />
            <Box
              sx={{
                display: "flex",
              }}
            >
              <UserButton />
            </Box>
          </Stack>
        </Stack>
      </TopBarWrapper>
    </Box>
  );
});

export default TopBar;
